import React from 'react';
import { Card, CardHeader, CardContent } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';


const cellStyle = {
  padding: '6px 16px 6px 12px',
  fontSize: '0.8rem'
}

const SamantektAtkvaediTable = (props) => {
  const { talning, embaetti } = props;

  if (talning.heildarfjoldi === undefined) {
    return (
      <Card>
        <CardHeader title={"Samantekt atkvæða"} subheader={embaetti} />
        <Divider />
        <CardContent>
          <Typography>Engin gögn fundust</Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader title={"Samantekt atkvæða - Talning"} subheader={embaetti} />
      <Divider />
      <CardContent>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell style={cellStyle}></TableCell>
              <TableCell style={cellStyle}>Alls</TableCell>
              <TableCell style={cellStyle}>Karlar</TableCell>
              <TableCell style={cellStyle}>Konur</TableCell>
              <TableCell style={cellStyle}>Kynsegin</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow hover>
              <TableCell style={cellStyle}>Atkvæði</TableCell>
              <TableCell style={cellStyle}>{talning.heildarfjoldi.alls}</TableCell>
              <TableCell style={cellStyle}>{talning.heildarfjoldi.karlar}</TableCell>
              <TableCell style={cellStyle}>{talning.heildarfjoldi.konur}</TableCell>
              <TableCell style={cellStyle}>{talning.heildarfjoldi.kynsegin}</TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell style={cellStyle}>Atkvæði í kassa</TableCell>
              <TableCell style={cellStyle}>{talning.heildarfjoldiKassa.alls}</TableCell>
              <TableCell style={cellStyle}>{talning.heildarfjoldiKassa.karlar}</TableCell>
              <TableCell style={cellStyle}>{talning.heildarfjoldiKassa.konur}</TableCell>
              <TableCell style={cellStyle}>{talning.heildarfjoldiKassa.kynsegin}</TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell style={cellStyle}>Atkvæði tekin með</TableCell>
              <TableCell style={cellStyle}>{talning.heildarfjoldiTekidMed.alls}</TableCell>
              <TableCell style={cellStyle}>{talning.heildarfjoldiTekidMed.karlar}</TableCell>
              <TableCell style={cellStyle}>{talning.heildarfjoldiTekidMed.konur}</TableCell>
              <TableCell style={cellStyle}>{talning.heildarfjoldiTekidMed.kynsegin}</TableCell>
            </TableRow>
            {/* <TableRow hover>
              <TableCell>Aðsend atkvæði</TableCell>
              <TableCell>{talning.heildarfjoldiAdsent.alls}</TableCell>
              <TableCell>{talning.heildarfjoldiAdsent.karlar}</TableCell>
              <TableCell>{talning.heildarfjoldiAdsent.konur}</TableCell>
            </TableRow> */}
            <TableRow hover>
              <TableCell style={cellStyle}>Atkvæði á heilbrigðisstofnun</TableCell>
              <TableCell style={cellStyle}>{talning.heildarfjoldiHeilbrigdisstofnun.alls}</TableCell>
              <TableCell style={cellStyle}>{talning.heildarfjoldiHeilbrigdisstofnun.karlar}</TableCell>
              <TableCell style={cellStyle}>{talning.heildarfjoldiHeilbrigdisstofnun.konur}</TableCell>
              <TableCell style={cellStyle}>{talning.heildarfjoldiHeilbrigdisstofnun.kynsegin}</TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell style={cellStyle}>Atkvæði í fangelsi</TableCell>
              <TableCell style={cellStyle}>{talning.heildarfjoldiFangelsi.alls}</TableCell>
              <TableCell style={cellStyle}>{talning.heildarfjoldiFangelsi.karlar}</TableCell>
              <TableCell style={cellStyle}>{talning.heildarfjoldiFangelsi.konur}</TableCell>
              <TableCell style={cellStyle}>{talning.heildarfjoldiFangelsi.kynsegin}</TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell style={cellStyle}>Atkvæði í heimahúsi</TableCell>
              <TableCell style={cellStyle}>{talning.heildarfjoldiHeimahus.alls}</TableCell>
              <TableCell style={cellStyle}>{talning.heildarfjoldiHeimahus.karlar}</TableCell>
              <TableCell style={cellStyle}>{talning.heildarfjoldiHeimahus.konur}</TableCell>
              <TableCell style={cellStyle}>{talning.heildarfjoldiHeimahus.kynsegin}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}

export default SamantektAtkvaediTable;